import { takeLatest, all, put } from 'redux-saga/effects';
import Promise from 'bluebird';
import omit from 'lodash/omit';

import weegoClient from '../../providers/weego-client';
import notificationActions from '../../actions/notification';

function* sendNotification({ payload }) {
  try {
    const { notification } = payload;
    yield Promise.map(notification.recipients, async recipient => {
      await weegoClient.notification.sendNotification({
        ...omit(notification, 'recipients'),
        phoneNumber: recipient.phoneNumber,
      });
    });
    yield put(notificationActions.sendNotificationSuccess());
  } catch (e) {
    console.error(e);
    yield put(notificationActions.sendNotificationError(e));
  }
}

function* requestNotificationsList({ payload }) {
  try {
    const response = yield weegoClient.notification.getChildrenNotification(
      payload,
    );
    yield put(notificationActions.updateNotificationsList(response));
  } catch (e) {
    alert('Erreur lors de la récupération de la liste des notifications');
    yield put(notificationActions.requestNotificationsListError(e));
  }
}

function* notificationRootSaga() {
  yield all([
    takeLatest(
      notificationActions.sendNotification.toString(),
      sendNotification,
    ),
    takeLatest(
      notificationActions.requestNotificationsList.toString(),
      requestNotificationsList,
    ),
  ]);
}

export default notificationRootSaga;
